$('[data-fancybox]').fancybox({
  infobar: false,
  toolbar: false
});

/*********************************************************
    Google Maps
*********************************************************/
var map;
function initMap() {
  map = new google.maps.Map(document.getElementById('map'), {
    //center: { lat: 48.794842, lng: 9.231301 },
    center: { lat: 49.065843, lng: 8.886208 },
    zoom: 9,
    styles: [
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'transit',
        stylers: [{ visibility: 'off' }]
      }
    ],
    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false
  });

  var markerIcon = {
    url: '/typo3conf/ext/wstheme/Resources/Public/icons/marker.svg',
    scaledSize: new google.maps.Size(30, 45)
  };

  var headquarters = {
    marker: {
      lat: 48.81879,
      lng: 9.26840

      // mannipulierte falsche Werte, damit man die Nadel besser erkennen kann
      // lat: 48.820923,
      // lng: 9.246325
    },
    content:
      '<div id="content">' +
      '<h4>Hauptverwaltung</h4>' +
      '<div id="bodyContent">' +
      '<p>Esslinger Str. 4<br />70736 Fellbach</p>' +
      '<p><strong>Telefon:</strong>&nbsp; <a href="tel:+49711578838200">+49 711 57 88 38 - 200</a><br /><strong>Fax:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+49 711 57 88 38 - 70</p>' +
      '<p><strong>E-Mail:</strong> &nbsp;&nbsp;&nbsp;<a href="mailto:recycling@pro-metall.com">recycling@pro-metall.com</a></p>' +
      '<p><a target="_blank" href="https://www.google.de/maps/dir//Prometall+GmbH,+Esslinger+Str.+4,+70736+Fellbach/@48.8187688,9.1984911,12z/data=!4m9!4m8!1m0!1m5!1m1!1s0x4799c5923fbbdaa9:0x58bf374e94dafa02!2m2!1d9.26853!2d48.81879!3e0">Routenplaner</a></p>' +
      '</div>' +
      '</div>'
  };

  var fellbach = {
    marker: {
      lat: 48.818666,
      lng: 9.266255
    },
    content:
      '<div id="content">' +
      '<h4>Betriebsstätte Fellbach</h4>' +
      '<div id="bodyContent">' +
      '<p>Eisenbahnstr. 37 - 41<br />70736 Fellbach</p>' +
      '<p><strong>Telefon:</strong>&nbsp; <a href="tel:+49711578838452">+49 711 57 88 38 - 452</a><br /><strong>Fax:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+49 711 57 88 38 - 70</p>' +
      '<p><strong>E-Mail:</strong>&nbsp;&nbsp;&nbsp;<a href="mailto:waage.fellbach@pro-metall.com">waage.fellbach@pro-metall.com</a></p>' +
        '<p><strong>Öffnungszeiten:</strong><br/>07.00 bis 09.00 Uhr<br/>09.30 bis 12.00 Uhr<br/>12.30 bis 16.00 Uhr</p>' +
      '<p><a target="_blank" href="https://www.google.de/maps/dir//Eisenbahnstra%C3%9Fe+37,+70736+Fellbach/@48.8186661,9.2640664,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x4799c591904f26d1:0xd90af4771b20b5d8!2m2!1d9.2662551!2d48.8186661!3e0">Routenplaner</a></p>' +
      '</div>' +
      '</div>'
  };

  var stuttgart = {
    marker: {
      lat: 48.770742,
      lng: 9.254411
    },
    content:
      '<div id="content">' +
      '<h4>Betriebsstätte Stuttgart</h4>' +
      '<div id="bodyContent">' +
      '<p>Am Mittelkai 4 - 6<br />70327 Stuttgart</p>' +
      '<p><strong>Telefon:</strong>&nbsp; <a href="tel:+49711578838250">+49 711 57 88 38 - 250</a><br /><strong>Fax:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+49 711 57 88 38 - 70</p>' +
      '<p><strong>E-Mail:</strong>&nbsp;&nbsp;&nbsp;<a href="mailto:waage.mittelkai@pro-metall.com">waage.mittelkai@pro-metall.com</a></p>' +
        '<p><strong>Öffnungszeiten:</strong><br />07.00 bis 09.00 Uhr<br />09.30 bis 16.00 Uhr</p>' +
      '<p><a target="_blank" href="https://www.google.de/maps/dir//ProMetall+GmbH,+Am+Mittelkai,+70327+Stuttgart/@48.7692838,9.1852296,12z/data=!4m9!4m8!1m0!1m5!1m1!1s0x4799c46a94b13d25:0x6a6f77749889e62c!2m2!1d9.2552685!2d48.769305!3e0">Routenplaner</a></p>' +
      '</div>' +
      '</div>'
  };

  var mannheim = {
    marker: {
      lat: 49.433945,
      lng: 8.520454
    },
    content:
      '<div id="content">' +
      '<h4>Betriebsstätte Mannheim</h4>' +
      '<div id="bodyContent">' +
      '<p>Bergiusstraße 4-8<br />68219 Mannheim</p>' +
      '<p><strong>Telefon:</strong>&nbsp; <a href="tel:+4962180396960">+49 621 80 39 69 - 60<br /><strong>Fax:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+49 711 57 88 38 - 70</p>' +
      '<p><strong>E-Mail:</strong>&nbsp;&nbsp;&nbsp;<a href="mailto:waage.mittelkai@pro-metall.com">waage.mannheim@pro-metall.com</a></p>' +
        '<p><strong>Öffnungszeiten:</strong><br />Mo-Do: 07.00 bis 12.30 Uhr / 13.00 bis 15.30 Uhr<br />Freitag: 07.00 bis 09.00 Uhr / 09.30 bis 14.00 Uhr</p>' +
      '<p><a target="_blank" href="https://www.google.de/maps/dir//Bergiusstraße,+68219+Mannheim/@49.433945,8.520454,12z/data=!4m9!4m8!1m0!1m5!1m1!1s0x4799c46a94b13d25:0x6a6f77749889e62c!2m2!1d8.520454!2d49.433945!3e0">Routenplaner</a></p>' +
      '</div>' +
      '</div>'
  };

  var fellbachWindow = new google.maps.InfoWindow({
    content: fellbach.content
  });

  var stuttgartMarker = new google.maps.Marker({
    position: stuttgart.marker,
    icon: markerIcon,
    map: map
  });
  var headquartersMarker = new google.maps.Marker({
    position: headquarters.marker,
    icon: markerIcon,
    map: map
  });
  var headquartersWindow = new google.maps.InfoWindow({
    content: headquarters.content
  });

  var fellbachMarker = new google.maps.Marker({
    position: fellbach.marker,
    icon: markerIcon,
    map: map
  });

  var stuttgartWindow = new google.maps.InfoWindow({
    content: stuttgart.content
  });

  // var mannheimMarker = new google.maps.Marker({
  //   position: mannheim.marker,
  //   icon: markerIcon,
  //   map: map
  // });
  // var mannheimWindow = new google.maps.InfoWindow({
  //   content: mannheim.content
  // });

  headquartersMarker.addListener('click', function () {
    fellbachWindow.close();
    stuttgartWindow.close();
    // mannheimWindow.close();

    headquartersWindow.open(map, headquartersMarker);
  });

  fellbachMarker.addListener('click', function () {
    headquartersWindow.close();
    stuttgartWindow.close();
    // mannheimWindow.close();

    fellbachWindow.open(map, fellbachMarker);
  });

  stuttgartMarker.addListener('click', function () {
    headquartersWindow.close();
    fellbachWindow.close();
    // mannheimWindow.close();

    stuttgartWindow.open(map, stuttgartMarker);
  });

  mannheimMarker.addListener('click', function () {
    headquartersWindow.close();
    fellbachWindow.close();
    stuttgartWindow.close();
    // mannheimWindow.open(map, mannheimMarker);
  });
}

/*********************************************************
  Scroll header
*********************************************************/
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.page__header').outerHeight();

$(window).scroll(function (event) {
  didScroll = true;
});

setInterval(function () {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 10);

function hasScrolled() {
  var st = $(this).scrollTop();

  if (Math.abs(lastScrollTop - st) <= delta) return;

  if (st > lastScrollTop && st > navbarHeight) {
    $('.page__header')
      .removeClass('header--up')
      .addClass('header--up');
  } else {
    if (st + $(window).height() < $(document).height()) {
      $('.page__header')
        .removeClass('header--up')
        .addClass('header--down');
    }
  }

  lastScrollTop = st;
}

$(document).ready(function () {
  /*********************************************************
    Device detection
  *********************************************************/
  (function () {
    var is_iPad = navigator.userAgent.match(/iPad/i) != null;
    var is_Edge = navigator.userAgent.match(/Edge/i) != null;
    var is_IE =
      navigator.appName == 'Microsoft Internet Explorer' ||
      !!(
        navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)
      ) ||
      (typeof $.browser !== 'undefined' && $.browser.msie == 1);

    if (is_iPad) {
      $('body').addClass('is-ipad');
    }

    if (is_Edge) {
      $('body').addClass('is-edge');
    }

    if (is_IE) {
      $('body').addClass('is-ie');
    }
  })();

  /*********************************************************
    Main slider
  *********************************************************/
  $('.slider--big').slick({
    responsive: [
      {
        breakpoint: 620,
        settings: {
          infinite: true,
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });

  /*********************************************************
    Services slider
  *********************************************************/
  $('.slider--services').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 835,
        settings: {
          arrows: false,
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  /*********************************************************
    Products and locations slider
  *********************************************************/
  $('.slider--products').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          arrows: false,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 835,
        settings: {
          arrows: false,
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  /*********************************************************
    Logos slider
  *********************************************************/
  $('.slider--logos').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 525,
        settings: {
          arrows: false,
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  $('.slider--logos-2').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 525,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });

  /*********************************************************
    Gallery slider
  *********************************************************/
  $('.gallery').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 630,
        settings: {
          arrows: false,
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  /*********************************************************
    Sub navigation
  *********************************************************/
  (function () {
    var className = 'navigation--is-open';

    $('.navigation--main .navigation__item--is-parent .navigation__link')
      .on('mouseenter', function () {
        $('.navigation--subnavigation').addClass(className);
      })
      .on('mouseleave', function () {
        $('.navigation--subnavigation').removeClass(className);
      });

    $('.navigation--subnavigation')
      .on('mouseenter', function () {
        $(this).addClass(className);
      })
      .on('mouseleave', function () {
        $(this).removeClass(className);
      });
  })();

  /*********************************************************
    Mobile menu
  *********************************************************/
  (function () {
    var className = 'page--menu-is-open';

    $('.hamburger').on('click', function () {
      $('html').toggleClass(className);
    });
  })();

  /*********************************************************
    Contact window
  *********************************************************/
  (function () {
    var className = 'contact-window--is-open';

    $('.contact-window .btn').on('click', function () {
      $('.contact-window').toggleClass(className);
    });

    $(document).on('click', function (e) {
      if ($(e.target).closest('.contact-window').length === 0) {
        $('.contact-window').removeClass(className);
      }
    });
  })();

  /*********************************************************
    Material cycle
  *********************************************************/
  (function () {
    $('.frame-type-wstheme_cycle .step').on('click', function () {
      var id = $(this).data('step');

      $('.frame-type-wstheme_cycle .step').removeClass('step--active');
      $('.frame-type-wstheme_cycle .step__text').removeClass('step--active');

      $('.frame-type-wstheme_cycle .step__text--' + id).addClass(
        'step--active'
      );

      for (var i = 1; i <= id; i++) {
        var selector = '#cycle .step--' + i;
        $(selector).addClass('step--active');
      }
    });
  })();

  /*********************************************************
    Check how many slider items should be visible
  *********************************************************/
  function checkItemsToShow() {
    console.log('Hier');
    return $('.slider--logos').data('show-items');
  }

  /*********************************************************
    Equal heights
  *********************************************************/
  $('.slider--products .box').equalHeights();
  $('.frame-type-wstheme_teaser .box').equalHeights();

  /*********************************************************
    IE fixes
  *********************************************************/
  if ($('body').hasClass('is-ie') && $('body').hasClass('page--id-30')) {
    setTimeout(function () {
      initMap();
    }, 1000);
  }
});

/*********************************************************
    Resize events
  *********************************************************/
$(window).resize(function () {
  $(window).resize(function () {
    $('.slider--products .box').height('auto');
    $('.slider--products .box').equalHeights();

    $('.frame-type-wstheme_teaser .box').height('auto');
    $('.frame-type-wstheme_teaser .box').equalHeights();
  });
});
